import React from "react";
import { Box, type SxProps, type Theme } from "@mui/material";
import { BRAND_GRADIENT, BRAND_INITIAL } from "../../constants";

interface BrandMarkProps {
  size?: number;
  fontSize?: number;
  borderRadius?: number;
  sx?: SxProps<Theme>;
}

const BrandMark: React.FC<BrandMarkProps> = ({
  size = 56,
  fontSize,
  borderRadius = 2,
  sx,
}) => {
  const computedFontSize = fontSize ?? Math.round(size * 0.43);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius,
        background: BRAND_GRADIENT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontWeight: 700,
        fontSize: computedFontSize,
        userSelect: "none",
        flexShrink: 0,
        ...sx,
      }}
    >
      {BRAND_INITIAL}
    </Box>
  );
};

export default BrandMark;
